module.exports = __webpack_public_path__ + "static/media/sudhir.5116d4f9.png";